<template>
    <div>
        <div class="row gx-3">
            <span class="col-auto">
                {{ documentStatus.Name }}
            </span>
            <span
                v-bind:class="documentStatus.IsComplete ? 'text-bubble-success' : ' text-bubble-warning'"
                class="col-auto">
                {{ documentStatus.Status }}
            </span>
        </div>
        <div
            v-for="(signatoryStatus, sIndex) in documentStatus.Signatories"
            v-bind:key="sIndex">
            <legacy-envelope-signatory-status-display v-bind:signatory-status="signatoryStatus" />
        </div>
    </div>
</template>
<script>
    import legacyEnvelopeSignatoryStatusDisplay from "./legacyEnvelopeSignatoryStatusDisplay.vue";

    export default {
        components: { legacyEnvelopeSignatoryStatusDisplay },
        props: {
            documentStatus: { type: Object, required: true, default: null }
        }
    };
</script>
